export default __webpack_public_path__ + "static/media/download.c03ef0ff.svg";